import { useEffect, useState } from "react";
import { fetchPublicDeals } from "../lib/adminApi";

// Fetches admin-published deals; maps title->name for card components.
export const useDeals = (fallback = []) => {
  const [deals, setDeals] = useState(null);
  useEffect(() => {
    let active = true;
    fetchPublicDeals()
      .then(({ data }) => { if (active) setDeals(data.map((d) => ({ ...d, name: d.title }))); })
      .catch(() => { if (active) setDeals([]); });
    return () => { active = false; };
  }, []);
  // While loading (null) or empty, use fallback demo deals
  const items = deals && deals.length ? deals : fallback;
  return items;
};
